import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Optional,
  Output,
  QueryList,
  Self,
  ViewChildren,
} from '@angular/core';
import { FormBuilder, FormGroup, NgControl, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatInput } from '@angular/material/input';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { LocalStorageService } from 'angular-web-storage';
import { ModelModalContactComponent } from 'src/app/components/dialogs/model-modal-contact/model-modal-contact.component';
import { ModelModalResendPasswordComponent } from 'src/app/components/dialogs/model-modal-resend-password/model-modal-resend-password.component';
import { LoadingService } from 'src/app/components/loading/loading-service.service';
import { AlertBarService } from 'src/app/services/alert-bar/alert-bar.service';
import { ApiService } from 'src/app/services/api/api.service';
import { GlobalService } from 'src/app/services/global/global.service';
import { TokenService } from 'src/app/services/token/token.service';

@Component({
  selector: 'app-step-three-token',
  templateUrl: './step-three-token.component.html',
  styleUrls: ['./step-three-token.component.scss'],
})
export class StepThreeTokenComponent implements OnInit {
  @ViewChildren(MatInput, { read: MatInput, emitDistinctChangesOnly: true })
  inputs?: QueryList<MatInput>;

  confirmationFormGroup!: FormGroup;
  phone: any;
  codeInterval: any;
  count: any;
  canCode = true;
  userData: any = [];
  title: any;
  update!: boolean;
  CPF: any;
  tempUserData: any = [];
  menu!: boolean;

  constructor(
    private fb: FormBuilder,
    private _snackBar: MatSnackBar,
    public storage: LocalStorageService,
    public dialog: MatDialog,
    @Self() @Optional() public ngControl: NgControl,
    public route: Router,
    private gf: GlobalService,
    private api: ApiService,
    private loader: LoadingService,
    private toast: AlertBarService,
    public routeActive: ActivatedRoute,
    public token: TokenService
  ) {
    if (ngControl) {
      ngControl.valueAccessor = this;
    }

    this.routeActive.data.subscribe((res: any) => {
      this.title = res.title;
      this.update = res.update;
    });
  }

  closeSnackBar() {
    this._snackBar.dismiss();
  }

  ngOnInit(): void {
    this.confirmationFormGroup = this.fb.group({
      code: [
        '',
        Validators.compose([
          Validators.required,
          Validators.minLength(4),
          Validators.maxLength(4),
        ]),
      ],
    });

    this.CPF = this.storage.get('CPF');
    this.userData = this.storage.get('userData');
    this.tempUserData = this.storage.get('TempUserData');

    if (!this.userData) {
      this.menu = false;
    }

    if (this.userData) {
      this.phone = this.userData.Phone;
    }

    this.token.getToken(
      this.userData
        ? this.userData.CPF
        : this.CPF
        ? this.CPF
        : this.tempUserData.CPF
    );
    this.loader.stopLoading();
  }

  onSubmit() {
    if (this.confirmationFormGroup.status == 'VALID') {
      this.loader.startLoading();

      const passCode = this.confirmationFormGroup.value.code;
      this.token.validateToken(
        this.userData
          ? this.userData.CPF
          : this.CPF
          ? this.CPF
          : this.tempUserData.CPF,
        passCode,
        (data: any) => {
          if (data.Sucesso) {
            if (this.userData || this.tempUserData) {
              this.storage.set(
                'userData',
                Object.assign(
                  this.userData ? this.userData : this.tempUserData,
                  {
                    voucher: passCode,
                  }
                )
              );
            } else {
              this.storage.set(
                'userData',
                Object.assign({
                  voucher: passCode,
                  CPF: this.CPF,
                })
              );
            }

            // Atualiza a senha a partir do voucher
            this.token.updatePasswordByVoucher(
              this.userData
                ? this.userData.CPF
                : this.CPF
                ? this.CPF
                : this.tempUserData.CPF,
              passCode,
              (data) => {
                if (data.Sucesso === true) {
                  localStorage.setItem('loginByVoucher', '1');
                  this.route.navigate(['/login']);
                }
              },
              (e) => {}
            );
          } else {
            this.loader.stopLoading();
            this.toast.openAlert(data.Mensagem, 'error');
            this.gf.toTop();
          }
        },
        (e: any) => {
          this.loader.stopLoading();
          this.toast.openAlert(e.error.Mensagem, 'error');
          this.gf.toTop();
        }
      );
    } else {
      this.toast.openAlert('Formulário inválido', 'error');
      this.gf.toTop();
    }
  }

  getWppCode() {
    this.getCode('whatsapp');
  }

  getCode(type = 'sms') {
    if (this.canCode) {
      this.token.getToken(
        this.token.cpf ? this.token.cpf : this.userData.CPF,
        type
      );

      this.canCode = false;

      let timeleft = 11;

      const downloadTimer = setInterval(() => {
        if (timeleft <= 1) {
          this.canCode = true;

          clearInterval(downloadTimer);
        }

        const count = 0 - timeleft;
        timeleft -= 1;

        this.count = timeleft;
      }, 1000);
    }
  }

  openDialogContact() {
    this.dialog.open(ModelModalContactComponent, {
      data: {
        icon: 'error_outline',
        textIcon: 'Atenção',
        title: 'O seu número de telefone está incorreto ?',
        text: 'Por questões de segurança, a atualização do telefone de cadastro deve ser feita via central de atendimento. Por favor, entre em contato.',
        textExtra: '',
        linkAdress: '',
        textLink: '',
      },
    });
  }

  openDialogResendPassword() {
    this.dialog.open(ModelModalResendPasswordComponent, {
      data: {
        icon: 'help_outline',
        textIcon: 'Ajuda',
        title: 'Reenviar senha!',
        text: 'Você também pode receber a senha por Whatsapp, basta selecionar a opção abaixo.',
        textExtra: '',
        linkAdress: '',
        textLink: '',
        sendSMS: () => {
          this.getCode();
        },
        sendWPP: () => {
          this.getWppCode();
        },
      },
    });
  }

  @Input() autofocus = false;
  @Input() length = 4;
  @Input() value: any;

  @Output() onChange = new EventEmitter<string>(true);

  get digits(): number[] {
    return new Array(this.length).fill(0).map((_, i) => i + 1);
  }

  get values(): any[] {
    return (this.value?.toString() || '')
      .split('')
      .concat(new Array(this.length).fill(''))
      .slice(0, this.length);
  }

  private _onChangeFn?: (value: any) => void;
  private _onTouchedFn?: () => void;

  writeValue(value: any): void {
    this.setValue(value, false);
  }

  registerOnChange(fn: any): void {
    this._onChangeFn = fn;
  }

  registerOnTouched(fn: any): void {
    this._onTouchedFn = fn;
  }

  handleKeyDownEvent(event: KeyboardEvent, control: any) {
    let i = 0;

    event.preventDefault();
    event.stopPropagation();

    const bypassKeys = ['Control', 'Shift', 'Alt', 'Tab'];

    const removeKeys = ['Delete', 'Backspace'];

    const { key, ctrlKey, code } = event;

    const removing = removeKeys.includes(key);

    if (bypassKeys.includes(key) || (ctrlKey && code.startsWith('Key'))) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    if (!/^[0-9]$/g.test(key) && !removing) {
      return;
    }

    const value: string = this.value ?? '';
    const newValue: string = (
      removing ? value.substring(0, value.length - 1) : value + key
    ).substring(0, this.length);

    this.confirmationFormGroup.controls['code'].setValue(newValue);
    this.setValue(newValue);

    i++;
  }

  handlePasteEvent(event: ClipboardEvent) {
    event.preventDefault();
    event.stopPropagation();

    const data = event.clipboardData?.getData('text/plain');
    if (typeof data !== 'string') {
      return;
    }

    const numbers = data.replace(/[^0-9]/gi, '');
    if (numbers.length === this.length) {
      this.setValue(numbers.toString());
    }
  }

  private setValue(value: string, emitChanges = true) {
    this.value = value;

    if (emitChanges) {
      const nextIndex =
        value.length < this.length ? value.length : value.length - 1;
      const nextInput = this.inputs?.get(nextIndex);
      nextInput?.focus;

      this._onChangeFn?.(value);
      this._onTouchedFn?.();
    }
  }
}
